import type { TChangeAssessmentConfig, TChangeDashboardTab, TChangeMockStatus } from './types';

export const CHANGE_MOCK_CURRENT_DATE = new Date('2026-07-10T00:00:00.000Z');

export const CHANGE_STATUS = {
  DRAFT: 'Draft',
  PENDING_REVIEW: 'Pending Review',
  IN_EXECUTION: 'In execution',
  IMPLEMENTED: 'Implemented',
  CLOSED: 'Closed',
  AI_ASSESSMENT_IN_PROGRESS: 'Assessment in progress',
  ADDITIONAL_INFORMATION_REQUIRED: 'Additional information required',
  ASSESSMENT_COMPLETE_PENDING_APPROVAL: 'Pending approval',
  APPROVED_FOR_EXECUTION: 'Approved for execution',
} as const satisfies Record<string, TChangeMockStatus>;

export const OPEN_CHANGE_STATUSES = new Set<string>([
  CHANGE_STATUS.DRAFT,
  CHANGE_STATUS.PENDING_REVIEW,
  CHANGE_STATUS.IN_EXECUTION,
  CHANGE_STATUS.AI_ASSESSMENT_IN_PROGRESS,
  CHANGE_STATUS.ADDITIONAL_INFORMATION_REQUIRED,
  CHANGE_STATUS.ASSESSMENT_COMPLETE_PENDING_APPROVAL,
]);

export const MY_CHANGE_OWNERS = new Set(['Dr. Anna Keller', 'Lukas Hartmann', 'Elena Rossi']);

export const CHANGE_TYPE_OPTIONS = ['', 'Product Maintenance', 'Regulatory Maintenance', 'Labeling and Usability'];

export const CHANGE_OWNER_OPTIONS = [
  '',
  'Dr. Anna Keller',
  'Lukas Hartmann',
  'Martin Vogt',
  'Elena Rossi',
  'Dr. Sofia Meier',
];

export const CHANGE_STATUS_OPTIONS = [
  '',
  CHANGE_STATUS.DRAFT,
  CHANGE_STATUS.PENDING_REVIEW,
  CHANGE_STATUS.IN_EXECUTION,
  CHANGE_STATUS.CLOSED,
];

export const CHANGE_TARGET_DATE_OPTIONS = ['', 'Due within 30 days', 'Overdue', 'Completed this year'];

export const CHANGE_TRIGGER_OPTIONS = [
  'Supplier discontinuation',
  'Supplier notification',
  'Product improvement',
  'Complaint or PMS signal',
  'Nonconformity',
  'Regulatory or standards update',
  'Manufacturing change',
  'Business or operational need',
  'Other',
];

export const CHANGE_COMPONENT_OPTIONS = [
  'Titanium raw material specification',
  'Sterile barrier packaging drawing',
  'Supplier qualification record',
  'Labeling and IFU master file',
  'Risk management file',
  'Design verification report',
  'Manufacturing work instruction',
];

export const CHANGE_DASHBOARD_TABS: { value: TChangeDashboardTab; label: string }[] = [
  { value: 'all', label: 'All changes' },
  { value: 'my', label: 'My changes' },
  { value: 'pending-review', label: 'Pending review' },
  { value: 'in-execution', label: 'In execution' },
  { value: 'closed', label: 'Closed' },
];

export const CHANGE_BEING_ASSESSED_LABEL = 'Being assessed';

export const CHANGE_ASSESSMENT_STAGE_DURATION = 20000;

export const CHANGE_DEFAULT_ASSESSMENT: Required<TChangeAssessmentConfig> = {
  questionDelay: CHANGE_ASSESSMENT_STAGE_DURATION,
  completionDelay: CHANGE_ASSESSMENT_STAGE_DURATION,
  messages: [
    'Reviewing the change description and supporting evidence',
    'Identifying affected product characteristics',
    'Searching the technical documentation for impacted content',
    'Assessing safety, performance and regulatory implications',
    'Preparing the implementation plan',
  ],
  continuationMessages: [
    'Evaluating the provided information',
    'Assessing impact on risk management and biological evaluation',
    'Identifying required verification activities',
    'Reviewing potential labeling and regulatory impacts',
    'Creating the proposed implementation plan',
  ],
  informationRequests: [],
};
